import { useSyncExternalStore } from 'react';
import { usePreferences } from './queries.js';

const query = typeof window !== 'undefined' ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
function subscribe(cb: () => void) {
  query?.addEventListener('change', cb);
  return () => query?.removeEventListener('change', cb);
}

/** True when motion should be reduced: the person's saved preference wins over the OS setting. */
export function useReducedMotionPreference(): boolean {
  const os = useSyncExternalStore(
    subscribe,
    () => query?.matches ?? false,
    () => false,
  );
  const prefs = usePreferences();
  const pref = prefs.data?.motionPreference ?? 'system';
  return pref === 'reduced' || (pref === 'system' && os);
}
